interface IAppResponse {
  data: { app: []; schema: []; appWarnings: [] };
}

interface IResponse {
  data: { content: []; totalElements: number };
}

export function formatAppListResponse(response: IAppResponse) {
 const responseData = response.data || {};
  const dataArray = responseData.app || responseData.schema || [];
  const warningsArray = responseData.appWarnings || [];
  let data = [] as any;
  let warnings = [] as any;
  if (!Array.isArray(dataArray)) {
    data.push(dataArray);
  } else {
    data = [...dataArray];
  }

  if (!Array.isArray(warningsArray)) {
    warnings.push(warningsArray);
  } else {
    warnings = [...warningsArray];
  }

  if(warnings?.[0]?.warningId){
    localStorage.setItem("warningId", warnings[0].warningId);
  } else{
    localStorage.removeItem("warningId");
  }

  if (warnings?.[0]) {
    const { btn1, btn2, btn3 } = warnings[0];
    localStorage.setItem("btn1", btn1 || "");
    localStorage.setItem("btn2", btn2 || "");
    localStorage.setItem("btn3", btn3 || "");
  } else {
    localStorage.removeItem("btn1");
    localStorage.removeItem("btn2");
    localStorage.removeItem("btn3");
  }
  
  return { data, warnings };
}

export function formatListResponse(response: IResponse) {
  const { content: data = [], totalElements: totalItems = 0 } = response.data;
  return { data, totalItems };
}
